// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"0f113f47204ede4a","5763":"f524a758c3cda9ec","6893":"fda9d6ccbefa94ed","6974":"292db1ff2e196afc","7222":"1503c28e186a3c43","7937":"1439eb4501201415"}[chunkId] + ".js";
};